import { Klydo, SoundMode } from '../api/klydo';

const FIRST_LOOP_MIN_VERSION = 613;
const SUBTITLE_MIN_VERSION = 614;
const ALARM_MIN_VERSION = 618;

/**
 * Lowest firmware version that can render every one of these klydos, or 0 when
 * anything will do.
 *
 * Mirrors ClockCollectionValidator.validateVersionRestriction in klydo-api,
 * which is the real gate — this copy only lets the studio show the "update your
 * clock" modal instead of a failed request.
 */
export const getRequiredClockVersion = (
  klydos: Pick<Klydo, 'subtitle' | 'capabilitiesV2'>[],
): number => {
  const hasFirstLoopSound = klydos.some(
    (klydo) =>
      klydo.capabilitiesV2?.animationSound?.mode === SoundMode.FIRST_LOOP,
  );
  const hasSubtitle = klydos.some((klydo) => !!klydo.subtitle?.trim());
  const hasAlarm = klydos.some((klydo) => !!klydo.capabilitiesV2?.alarm);

  return Math.max(
    hasFirstLoopSound ? FIRST_LOOP_MIN_VERSION : 0,
    hasSubtitle ? SUBTITLE_MIN_VERSION : 0,
    hasAlarm ? ALARM_MIN_VERSION : 0,
  );
};
